import { useLazyQuery } from '@apollo/client'

import { GetProductModalSupplierDeliveryFeesDocument } from '@/graphql/purchase-plus/generated/getProductModalSupplierDeliveryFees.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductModalSupplierDeliveryFeesProps {
  tradeRelationshipId: number
}

export const useGetProductModalSupplierDeliveryFees = ({
  tradeRelationshipId,
}: UseGetProductModalSupplierDeliveryFeesProps) => {
  const [fetchProductModalSupplierDeliveryFees, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetProductModalSupplierDeliveryFeesDocument,
    {
      variables: {
        tradeRelationshipId,
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
    }
  )

  const deliveryFees = data?.tradeRelationship?.deliveryCharge

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchProductModalSupplierDeliveryFees,
    error,
    deliveryFees,
    loadingStates,
    refetch,
  }
}
